import PropTypes from 'prop-types';
import React from 'react';
import SurveyType from 'types/survey';
import PhaseType from 'types/phase';

export const customer_survey_updated = ({ event: { kind, data: { comment, questions } } }) =>
  <div className={kind}>
    {questions.map((q) => {
      const answers = q.answers.map(a => <span key={a.id}>{a.label}: {a.value || '\u2014'} </span>);
      return <p key={q.id}><strong>{q.label}</strong><br />{answers}</p>;
    })}

    <p><strong>Additional Comments:</strong><br />{comment}</p>
  </div>;

customer_survey_updated.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: SurveyType.isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/customer_survey_updated.jsx